import { keycloak } from 'shared/keycloak';
import styles from './logout-button.module.scss';

export const LogoutButton = () => (
  <a
    className={styles.logoutButton}
    onClick={() => {
      keycloak?.logout();
    }}
  >
    Выйти
  </a>
);
